import { useMutation } from "react-query";
import axios, { AxiosError } from "axios";
import UpdateTagMetadataApiRequest from "../request/UpdateTagMetadataApiRequest";

const UpdateTagMetadataApiService = async (
  request: UpdateTagMetadataApiRequest
): Promise<boolean> => {
  const url = `/employertag/${request.id}/`;
  const { data } = await axios.patch(url, {
    name: request.name,
    category: request.category,
  });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useUpdateTagMetadataApiService = () =>
  useMutation<boolean, AxiosError, UpdateTagMetadataApiRequest>(
    UpdateTagMetadataApiService,
    {
      mutationKey: "UpdateTagMetadataApiService",
    }
  );

export default useUpdateTagMetadataApiService;
